import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const ACCOUNT_USER_COUNT_QUERY_KEY = 'account-user-count-key';

export function useAccountUserCount({ accountId, meta }: { accountId: string; meta?: LevStandardQueryMeta }) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			new Promise<number>((resolve, reject) =>
				userSession.webServiceHelper.callWebServiceWithOperationResults<number>(
					`account/${accountId}/userCount`,
					'GET',
					null,
					opResult => {
						resolve(opResult.value);
					},
					opResult => {
						reject(opResult);
					}
				)
			),
		queryKey: [ACCOUNT_USER_COUNT_QUERY_KEY, accountId],
		meta,
	});
}

export const invalidateAccountUserCount = (accountId: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [ACCOUNT_USER_COUNT_QUERY_KEY, accountId] });
};
